import { useEffect, useRef } from 'react';
import { AnalyticsEventLocation, ContactRepModalDetails } from '@mb/lib';
import {
  AnalyticsEventAPQAction,
  AnalyticsEventName,
  sendAnalyticsEvent,
} from '../utils/helpers/analytics';

export const useAnalyticsEvents = (
  isOpen: boolean,
  modalDetails?: ContactRepModalDetails,
) => {
  const analyticsEventSentForPopupOpen = useRef(false);

  useEffect(() => {
    const analyticsParams = {
      event: AnalyticsEventName.CONTACT_REP,
      // TODO: refactor without type assertion, or add comment
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      event_location: modalDetails?.data
        ?.event_location as AnalyticsEventLocation,
    };

    if (isOpen) {
      sendAnalyticsEvent({
        ...analyticsParams,
        action: AnalyticsEventAPQAction.OPEN,
      });
      analyticsEventSentForPopupOpen.current = true;
    } else if (analyticsEventSentForPopupOpen.current) {
      sendAnalyticsEvent({
        ...analyticsParams,
        action: AnalyticsEventAPQAction.CLOSE,
      });
      analyticsEventSentForPopupOpen.current = false;
    }
  }, [isOpen]);
};
